import classNames from 'classnames';
import { useIntl } from 'react-intl';
import SegnalazioniHead from '@components/segnalazioni/head/head';
import SegnalazioniAccordions from '@components/segnalazioni/accordions/accordions';
import { PageHead } from '../../components/common/head/page-head';
import { Navbar } from '../../components/common/navbar/navbar';
import styles from './index.module.css';
import { useSiteData } from '../../context/site-data-context';

export default function CentriDiEccellenza() {
  const { serviceCategories, technologyCategories } = useSiteData();
  const intl = useIntl();

  return (
    <>
      <PageHead
        title={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - Segnalazioni',
          description: 'Segnalazioni - Page title'
        })}
        description={intl.formatMessage({
          defaultMessage: 'Sistemi Informativi S.r.l. - Segnalazioni',
          description: 'Segnalazioni - Page description'
        })}
      />
      <Navbar
        navCssClasses={classNames(styles.navbarBackground, 'position-fixed')}
        navLinkCssClasses={styles.navItem}
        serviceCategories={serviceCategories}
        technologyCategories={technologyCategories}
      />
      <main role="main" className="mt-5">
        <div className="container-fluid m-0 p-0">
          <SegnalazioniHead />
          <SegnalazioniAccordions />
        </div>
      </main>
    </>
  );
}
